import Toggle from "./Toggle.js"

export default class Mute extends Toggle {

  constructor(props, context) {
    super(props, context)
    this.state.level = ""
    this.classList.add("amp-mute", true)
    this.state.altText = "MSG_MUTE"
  }

  static get contextTypes() {
    return super.contextTypes
  }

  get className() {
    return `${super.className} ${this.state.level}`
  }

  onChange() {
    const player = this.player
    player.muted = !player.muted
  }

  onMouseOver(event) {
  	this.plugin.dispatchEvent(new akamai.amp.Event("mutemouseover"))
  }

  onMouseOut(event) {
  	this.plugin.dispatchEvent(new akamai.amp.Event("mutemouseout"))
  }

  onvolumechange() {
    let level = ""

    if (this.player.muted) {
      level = "amp-muted"
    } else if (this.player.volume < 0.5) {
      level = "amp-low"
    }

    this.setState({level})
  }
}
